import styled from "@emotion/styled";

export const PageContainter = styled.div`
  max-width: 900px;
  padding: 24px;
  padding-top: 0;
  margin: auto;
`;

const Info = styled.div`
  background-color: #181818;
  padding: 24px;
  border-radius: 8px;
`;

export const PageHeading = styled.h2`
  text-align: center;
  margin-bottom: 32px;
`;

export const Para = styled.section`
  margin-bottom: 24px;
`;

export const ParaHeading = styled.h3`
  margin-bottom: 16px;
`;

export const P = styled.p`
  font-size: 14px;
  margin-bottom: 6px;
  line-height: 150%;
  text-align: justify;
`;

export const Br = styled.div`
  height: 12px;
`;

export const TextCenter = styled.div`
  text-align: center;
`;

export const Li = styled.li`
  font-size: 14px;
  margin-bottom: 6px;
  line-height: 150%;
  text-align: justify;
`;

export const Image = styled.img`
  width: 320px;
  height: auto;
  border: 5px solid #808080;
  max-width: 80vw;
`;

export const ImageAndNameHolder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 12px;
`;

export const ThumbImage = styled.img`
  width: 50px;
  height: auto;
`;

export const JapneseNumbers = styled.div`
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
`;

const Dojo = () => {
  return (
    <PageContainter>
      <Br />
      <Br />
      <PageHeading>Dojo Etiquettes</PageHeading>
      <Info>
        <ParaHeading>
          All members entering the Dojo must adhere to the following:
        </ParaHeading>
        <Para>
          <P>1) Bow on entrance and exit of the Dojo.</P>
          <P>
            2) When one of the sensei's (Teachers) talks to you, you must reply
            "Oss!"This also applies whenever a senior grade or Sempai (Assistant
            Instructor) talks to you, DO NOT refer to them with their name. This
            can only happen when outside of the training Dojo, no matter how
            friendly you are.
          </P>
          <P>3) No eating in the Dojo especially chewing gum.</P>
          <P>4) No smoking in the Dojo.</P>
          <P>5) No swearing in the Dojo.</P>
          <P>
            6) You are always welcome to ask questions during a lesson. However,
            it's best to wait for an appropriate moment, always raise your hand
            and say "Oss Sensei" before your question. NEVER interrupt a Sensei.
            Alternatively, wait until the end of the lesson.
          </P>
          <P>
            7) During the lesson, whilst in stances or any other technique, stay
            in position. DO NOT bite your nails, play with your uniform or
            slouch. Nothing looks worse than a line of untidy karateka,
            especially to new members or visitors to the club.
          </P>
          <P>
            8) Keep your Gi (Suit) washed and clean, not necessarily ironed.
            Nobody wants to train next to a smelly individual. Teenagers and
            adults are asked to apply anti-persperant before training.
          </P>
          <P>
            9) No jewellery is to be worn. Flat plain studs are allowed and any
            wedding ring that can't be removed must be covered with a plaster.
          </P>
          <P>
            10) Finger nails and toe nails must be clean and cut short. Hair
            must be clean and tied back, if long.
          </P>
          <P>
            11) No talking during lessons, even if you are partnered up with
            another person. You must not talk unless you are invited to do so by
            a Sensei or assistant instructor.
          </P>
          <P>
            12) No running about or pretend fighting before the lesson starts.
            Only light contact fighting is allowed in karate and this is only
            with supervision during a class.
          </P>
          <P>
            13) DO NOT use karate at work or school for messing about or showing
            off. Karate should only be practised at home, during a karate class
            or used to defend yourself, family, or friends from a serious
            attacker. If a student is found to be doing karate at school (for
            instance), he/she may be asked to leave the association.
          </P>
          <P>
            14) Any member that forgets their fees, when due, will not be
            allowed to train. Please do not embarrass yourself or an instructor
            by asking to train without your fees being paid.
          </P>
          <P>
            15) Constant lateness into the class is very bad manners and this
            also disturbs the class in progress. All students must turn up early
            to get changed, warm-up, and prepare for the lesson, with a minimum
            of 5 minutes until the lesson starts. A student that arrives more
            than 10 minutes late will not be allowed to enter.
          </P>
          <P>
            16) DO NOT wear your karate suit or show your belt in public. Cover
            up with a tracksuit or coat. Alternatively, copy the higher grades
            by getting changed before and after the lesson in the facilities
            provided. Parents are welcome to stay with their child while they
            get changed.
          </P>
          <P>
            17) The taking of drugs is prohibited. Any students found to be
            taking OR intending to take these substances will be removed from
            the association. This is in co-operation with the doping rules made
            by WADA and WKF.
          </P>
        </Para>
        <Para>
          <b>Conduct For Students</b>
          <Br />

          <Li>
            {" "}
            Have fun, act in a safe manner and encourage everyone around them to
            do the same.
          </Li>
          <Li>
            {" "}
            Always respect those around them, including other students,
            opponents, instructors, officials and parents.
          </Li>
          <Li>
            {" "}
            Be honest and fair in everything they do and never deliberately be
            dishonest.
          </Li>
          <Li>
            {" "}
            Accept instructors’ and officials’ decisions without question or
            complaint.
          </Li>
          <Li>
            {" "}
            Arrive for training and other events on time and inform someone if
            they will be late.
          </Li>
          <Li>
            {" "}
            Listen carefully when spoken to and act as directed where
            appropriate.
          </Li>
          <Li>
            {" "}
            Make sure you have correct uniform with you and look after it to the
            best of your ability. This includes suit, belt and mitts.
          </Li>
          <Li>
            {" "}
            Make sure your hair is off your face, your finger and toe nails are
            short and you have no jewellery on during events.
          </Li>
          <Li>
            {" "}
            Never upset those around you,and inform an instructor if you know if
            someone else is upset.
          </Li>
          <Li> Always do your best and give 100% effort in whatever you do.</Li>
          <Li>
            {" "}
            As a adults and young persons taking part in martial arts, you will
            recognise that you are an ambassador in your discipline and others
            taking parts in martial arts.
          </Li>
          <Li>
            {" "}
            Never post any photos or words on a social network site which could
            put yourself in danger, or embarass yourself, your family, your club
            or anyone else in martial arts.
          </Li>
          <Li>
            {" "}
            Never use martial arts outside of the training environment except in
            the defence of yourself, family or friends in the instance of
            extreme danger or unprovoked attack.
          </Li>
          <Li>
            {" "}
            Read and understand the clubs rules and terms and conditions.
          </Li>
          <Li> Make sure your licence is kept in date.</Li>
        </Para>
        <Para>
          <b>Procedure for bad behaviour</b>
          <Br />
          <P>
            Recent studies have shown that teaching children martial arts is
            more effective at teaching children to behave properly, than
            traditional physical education or schooling.
          </P>
          <Br />
          <P>
            Over the last century education has changed dramatically in schools
            and discipline & respect has declined. Many parents send their
            children to our classes, to teach their young ones discipline,
            respect, learning to obey rules and gain good attitude. To do this,
            we as instructors teach the traditional Japanese way, which may come
            across to some as being quite regimental/strict. We have set rules
            in our association and we explain from day one what behaviour is
            acceptable and what we expect from each student.
          </P>
          <Br />
          <P>
            All bad behaviour is dealt with immediately. We have very few cases
            of bad behaviour occurring in our classes but minor incidences do
            happen from time to time.
          </P>
          <P>
            1) a student who behaves badly is NEVER made fun of or ridiculed in
            front of the class
          </P>
          <P>
            2) a student who behaves badly is NEVER handled or touched in any
            way
          </P>
          <P>
            3) a student that behaves badly and has been dealt with
            appropriately is ALWAYS given second chances, with no hard feelings.
            We always accept people willing to change or improve behaviour.
          </P>
          <P>
            4) a student who has behaved badly is ALWAYS spoken to appropriately
            and respectfully
          </P>
          <Br />
          <P>
            For odd occasions when a student accidently lapses in their
            ettiquette (bad word without thinking, talking out of turn,
            wandering about inappropriately ect) a student will be spoken to by
            the instructor and asked why they have been taken to one side. This
            allows the student to go back over their actions and figure out for
            themselves what they may have done. The instructor will then explain
            why the behaviour was not accepted and the student may get a small
            punishment of a few pushups for this. This is generally enough to
            remind them not to repeat the behaviour. Small lapses in behaviour
            are expected from time to time and we can appreciate this will
            happen, due to having young children in the class.
          </P>
          <Br />
          <P>
            For adults or children that are knowingly breaching rules. For
            instance, intentionally causing a nervous/bad atmosphere, aggressive
            behaviour, disrupting the lesson for others, using bad language,
            rude to others, danger to others... we do have a process that we
            would follow (no matter if it's an adult, or a child):
          </P>
          <Br />
          <P>
            1) We take the student out of the lesson (with another instructor or
            3rd party as proof of the conversation). We ask the student to
            explain their behaviour and then we provide them with information
            about why their behaviour is not acceptable and how we wish them to
            behave, from then on. We give the student a 'time out/cooling off
            period' by sitting a child at the side of the lesson for 5 minutes
            OR allowing an adult to go to the toilet or get a drink. The student
            will be called by the instructor, when they can join back in the
            class, with a fresh start.
            <Br />
          </P>
          <P>
            2) If behaviour continues (whether in the same lesson or in the next
            few sessions) then the same happens as above. However, this time the
            parent will be told of the behaviour (if it's a child) or a written
            warning is given to an adult student. The conversation or letter
            will explain that if the behaviour continues then we will have to
            suspend the student from the association, for a month or more
            (depending on the severity of the behaviour). After the completed
            suspension time, they will be allowed to return to their karate
            training but their behaviour will be watched closely.
            <Br />
          </P>
          <P>
            3) If after a suspension period the behaviour does not change OR if
            a student does something very bad (fighting in public, hitting
            another student when we are not sparring, aggressive behaviour to
            the instructors), then we will exclude the student from the
            association completely.
          </P>
          <Br />
          <P>
            Although we try our very best to make respectful/well mannered
            people out of everyone, it is sometimes not always possible. We can
            give many second chances and try our very best to change around
            someone that struggles with their behaviour. But, at the end of the
            day we do have to think about our other students welfare and the
            fact they are paying to be kept safe and taught well. We also have
            to keep all our instructors and assistant instructors safe at all
            times and provide an enjoyable atmosphere and association for
            everyone.
          </P>
        </Para>
        <Para>
          <b>Conduct For Parents/Guardians of karate students under 16</b>
          <Br />
          <Li>
            {" "}
            Focus on the child’s efforts and enjoyment rather than winning or
            losing.
          </Li>
          <Li>
            {" "}
            Provide positive verbal feedback after training, grading sessions
            and tournaments.
          </Li>
          <Li>
            {" "}
            Encourage students to participate within the rules and regulations
            of the martial arts.
          </Li>
          <Li>
            {" "}
            Congratulate all participants on their performance regardless of who
            they are or what the outcome.
          </Li>
          <Li>
            {" "}
            Leave the Instructor to communicate with individual students during
            the session/event.
          </Li>
          <Li>
            {" "}
            Respect the decisions of officials and teach children to do the
            same.
          </Li>
          <Li>
            {" "}
            Respect Instructors, referees, judges, students and spectators.
          </Li>
          <Li>
            {" "}
            Inform the Instructor of any injury, health or welfare issue that is
            appropriate for them to know.
          </Li>
          <Li>
            {" "}
            Ensure that your child/children arrive on time and are collected
            promptly for training and other events.
          </Li>
          <Li>
            {" "}
            Remember that children participate in martial arts for their
            enjoyment, not the parents.’
          </Li>
          <Li> Payments to be paid regularly and on time</Li>
          <Li> Alway provide your child with correct, clean uniform to wear</Li>
          <Li>
            {" "}
            Provide children with correct freestyle equipment (Higher Grades),
            otherwise they will not be able to take part in that activity.
          </Li>
          <Li>
            {" "}
            Respect the rights, dignity, and worth of every person within
            martial arts. Do not downgrade any instructor or any other style.
          </Li>
          <Li>
            {" "}
            Report any concerns you may have in relation to a young person, to
            the Club Welfare Officer (Sensei Sarah Fullarton)
          </Li>
          <Li>
            {" "}
            Challenge and/or report discrimatory behaviour you may see from
            other parents or students.
          </Li>
          <Li>
            {" "}
            Ensure licences are kept in date and renewal forms are handed in on
            time.
          </Li>
          <Li>
            {" "}
            Read and understand the clubs rules and terms and conditions.
          </Li>
          <Br />
          <b>Don'ts</b>
          <Br />
          <Li>
            {" "}
            Force their child/children to participate in martial arts, if they
            do not wish to.
          </Li>
          <Li>
            {" "}
            Ridicule or shout at their child/children or other students for
            making a mistake or failing a grading.
          </Li>
          <Li>
            {" "}
            Publicly question the referee, judge, instructor or student’s
            decisions within a tournament, grading or training situation.
          </Li>
          <Li> Use foul, sexist, racist language or gestures at any times.</Li>
          <Li>
            {" "}
            Leave your child/children at the training venue/event, before the
            instructor has arrived.
          </Li>
          <Li> Condone behaviour that contravenes the codes of conduct.</Li>
          <Li>
            {" "}
            Bring young children or babies to watch classes, unless they are
            quiet. We can still hear noises through our closed doors.
          </Li>
          <Li> Leave other siblings unattended at any of our club venues.</Li>
        </Para>
      </Info>
    </PageContainter>
  );
};

export default Dojo;
